import { IMapState } from '../../types';

export function selectLargePinsZoom(state: IMapState): number {
  return state.map.infrastructure.config.largePinsZoom;
}
